import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icon';

const CardCurrentSchoolInteriorCardIcon = ({ fill='#024CBC', ...props }) => {
  return (
    <Icon viewBox="0 0 64 64" {...props}>
      <defs>
        <path
          id="aIC"
          d="M23.492 28.377v4.37c0 .346-.288.625-.652.654l-.012.003h-.029l-.02.002-.02-.002h-1.904l-.815 5.39-.005.01c-.026.342-.33.613-.707.613H16.67c-.358 0-.651-.245-.702-.562 0-.003-.004-.007-.004-.01l-.818-5.44h-1.904l-.02.001c-.393 0-.712-.295-.712-.658v-4.37c0-.01.004-.018.005-.026-.001-.009-.005-.016-.005-.025 0-2.8 2.463-5.078 5.491-5.078 3.029 0 5.492 2.278 5.492 5.078 0 .009-.005.016-.006.025.001.008.006.016.006.025m-5.514-12.85c1.885 0 3.414 1.43 3.414 3.194 0 1.763-1.529 3.192-3.414 3.192-1.886 0-3.414-1.43-3.414-3.192 0-1.764 1.528-3.193 3.414-3.193m14.217 2.834H27.83v-4.649c0-2.045-1.712-3.718-3.804-3.718h-4.284V7.299l4.801-1.937a.663.663 0 0 0 .421-.613.664.664 0 0 0-.42-.614l-4.802-1.937v-.381C19.742.813 18.91 0 17.883 0c-.015 0-.03.004-.046.005-.018 0-.036-.005-.055-.004-.32.009-.611.109-.86.268a1.8 1.8 0 0 0-.897 1.548v8.178h-3.89c-2.093 0-3.805 1.673-3.805 3.718v4.65H3.805C1.712 18.362 0 20.035 0 22.08v17.2c0 2.046 1.712 3.72 3.805 3.72h28.39C34.288 43 36 41.326 36 39.28v-17.2c0-2.045-1.712-3.719-3.805-3.719"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <rect width="64" height="64" fill={fill} rx="5" />
        <g transform="translate(14.603 9.83)">
          <mask id="bIC" fill="#fff">
            <use xlinkHref="#aIC" />
          </mask>
          <use fill="#000" xlinkHref="#aIC" />
          <g fill="#FFF" mask="url(#bIC)">
            <path d="M0 0h44v43H0z" />
          </g>
        </g>
      </g>
    </Icon>
  );
};

CardCurrentSchoolInteriorCardIcon.propTypes = {
  fill: PropTypes.string,
};

export default CardCurrentSchoolInteriorCardIcon;
